import { defineStore } from 'pinia'

export const useErrorStore = defineStore('error', {
  state: (): { errorMessage: string | null } => ({
    errorMessage: null,
  }),
  actions: {
    setError(message: string) {
      this.errorMessage = message
    },
    clearError() {
      this.errorMessage = null
    },
  },
})
